import IsVisible from './IsVisible'

export default IsVisible
